import { TranslateService } from "@ngx-translate/core";

const constructWelcomeString = (translate: TranslateService, userName: string): Promise<string> =>
  new Promise((resolve) => {
    translate.get("Onboarding.Welkom").subscribe((translation: string) => {
      resolve(userName ? `${translation} ${userName}` : translation);
    });
  });
export default constructWelcomeString;
